import React from "react";
import {
  FaHeartbeat,
  FaUserMd,
  FaShieldAlt,
  FaProcedures,
  FaVial,
  FaClock,
} from "react-icons/fa";
import "./Services.css";

const Services = () => {
  // Services data for display
  const servicesData = [
    {
      icon: <FaProcedures />,
      title: "Angiography",
      description:
        "Advanced X-ray imaging technique to examine blood vessels and identify blockages in coronary arteries for precise diagnosis.",
      duration: "15-30 minutes",
    },
    {
      icon: <FaVial />,
      title: "Angioplasty",
      description:
        "Minimally invasive procedure to open blocked arteries by removing plaque buildup and restoring proper blood flow to the heart.",
      duration: "1-2 hours",
    },
    {
      icon: <FaHeartbeat />,
      title: "Stent Placement",
      description:
        "Tiny metal tube insertion to keep arteries open after angioplasty, ensuring sustained blood flow and preventing re-narrowing.",
      duration: "1-2 hours",
    },
    {
      icon: <FaShieldAlt />,
      title: "Valvuloplasty",
      description:
        "Treatment to repair narrowed heart valves, improving blood flow and restoring proper heart function through specialized procedures.",
      duration: "2-3 hours",
    },
    {
      icon: <FaProcedures />,
      title: "TAVR",
      description:
        "Minimally invasive procedure to replace damaged aortic valves without open-heart surgery, using advanced catheter technology.",
      duration: "2-3 hours",
    },

    {
      icon: <FaVial />,
      title: "Fractional Flow Reserve (FFR)",
      description:
        "Advanced diagnostic technique to assess the significance of coronary artery blockages and determine their impact on blood flow.",
      duration: "30-45 minutes",
    },
    {
      icon: <FaProcedures />,
      title: "Chronic Total Occlusion (CTO)",
      description:
        "Specialized treatment for long-standing complete artery blockages using advanced interventional techniques to restore blood flow.",
      duration: "2-4 hours",
    },
    {
      icon: <FaVial />,
      title: "Atherectomy (IVL, ROTA, ORBITAL)",
      description:
        "Advanced procedures for fatty and calcific plaque modification in arteries, using specialized techniques to clear blockages and improve blood flow to the heart.",
      duration: "1-2 hours",
    },
    {
      icon: <FaProcedures />,
      title: "Pericardiocentesis",
      description:
        "Emergency procedure to remove excess fluid around the heart, relieving pressure and preventing life-threatening complications.",
      duration: "30-45 minutes",
    },
    {
      icon: <FaProcedures />,
      title: "Cardiac Catheterization",
      description:
        "Diagnostic and treatment procedure using thin catheters to examine heart function and treat various cardiac conditions.",
      duration: "1-2 hours",
    },
    {
      icon: <FaVial />,
      title: "Endovenous Thermal Ablation",
      description:
        "Minimally invasive treatment for varicose veins using laser or radiofrequency energy to seal off problematic veins.",
      duration: "45-60 minutes",
    },
    {
      icon: <FaHeartbeat />,
      title: "ECG",
      description:
        "Non-invasive test to record the electrical activity of your heart. Helps diagnose heart rhythm problems and heart attacks.",
      duration: "15-20 minutes",
    },
    {
      icon: <FaUserMd />,
      title: "Heart Checkup",
      description:
        "Comprehensive cardiac evaluation including physical examination, risk assessment, and preventive recommendations.",
      duration: "45-60 minutes",
    },
    {
      icon: <FaClock />,
      title: "Stress Test",
      description:
        "Exercise stress test to evaluate how your heart responds to physical exertion and identify coronary artery disease.",
      duration: "30-45 minutes",
    },
    {
      icon: <FaUserMd />,
      title: "Echocardiography",
      description:
        "Ultrasound imaging of the heart to assess heart structure, function, and blood flow patterns.",
      duration: "30-40 minutes",
    },
    {
      icon: <FaShieldAlt />,
      title: "Preventive Cardiology",
      description:
        "Risk assessment, lifestyle counseling, and preventive strategies to maintain optimal heart health.",
      duration: "60 minutes",
    },
    {
      icon: <FaClock />,
      title: "Cardiac Consultation",
      description:
        "Expert consultation for heart-related concerns, second opinions, and treatment planning.",
      duration: "30-45 minutes",
    },
    {
      icon: <FaHeartbeat />,
      title: "Percutaneous Device Closures",
      description:
        "Minimally invasive procedures to close structural heart defects using specialized closure devices.",
      duration: "1-2 hours",
    },
    {
      icon: <FaHeartbeat />,
      title: "Pacemaker Implantation",
      description:
        "Surgical placement of pacemakers to regulate abnormal heart rhythms and ensure proper heart function.",
      duration: "1-2 hours",
    },
    {
      icon: <FaHeartbeat />,
      title: "Cardiac Resynchronising Therapy (CRT)",
      description:
        "Advanced pacemaker therapy that coordinates the pumping action of both heart chambers to improve heart function.",
      duration: "2-3 hours",
    },
    {
      icon: <FaShieldAlt />,
      title: "AICD Implantation",
      description:
        "Implantation of devices that monitor heart rhythm and deliver electrical shocks when life-threatening arrhythmias are detected.",
      duration: "2-3 hours",
    },
    {
      icon: <FaProcedures />,
      title: "Mechanical Thrombectomy",
      description:
        "Advanced procedure to remove blood clots from arteries using specialized devices, restoring blood flow and preventing tissue damage.",
      duration: "1-2 hours",
    },
    {
      icon: <FaVial />,
      title: "Peripheral Vascular Intervention",
      description:
        "Minimally invasive treatment for blocked arteries in the legs, arms, and other peripheral vessels to improve circulation and relieve symptoms.",
      duration: "1-3 hours",
    },
    {
      icon: <FaHeartbeat />,
      title: "Renal Denervation Therapy",
      description:
        "Innovative treatment for resistant hypertension using radiofrequency energy to reduce nerve activity in the kidneys and lower blood pressure.",
      duration: "1-2 hours",
    },
    {
      icon: <FaProcedures />,
      title: "Renal Artery Stenting",
      description:
        "Procedure to open narrowed renal arteries using stents, improving blood flow to the kidneys and treating renovascular hypertension.",
      duration: "1-2 hours",
    },
    {
      icon: <FaShieldAlt />,
      title: "TEVAR (Thoracic Endovascular Aortic Repair)",
      description:
        "Minimally invasive repair of thoracic aortic aneurysms using stent grafts inserted through blood vessels, avoiding open chest surgery.",
      duration: "2-4 hours",
    },
    {
      icon: <FaHeartbeat />,
      title: "MVR – Mitral Valve Repair / Replacement",
      description:
        "Surgical treatment for damaged mitral valves, either through repair techniques to preserve the natural valve or complete replacement with prosthetic valves to restore proper heart function.",
      duration: "3-5 hours",
    },
    {
      icon: <FaVial />,
      title: "ELCA (Excimer Laser Coronary Atherectomy)",
      description:
        "Advanced laser-based procedure to remove complex coronary artery blockages using ultraviolet light energy, particularly effective for calcified and fibrotic lesions that are difficult to treat with conventional methods.",
      duration: "1-2 hours",
    },
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="services-hero-content">
            <h1 style={{ fontSize: "1.8rem" }}>Our Cardiology Services</h1>
            <p style={{ fontSize: "var(--font-size-base)" }}>
              Advanced interventional cardiology procedures with
              state-of-the-art technology and expert medical professionals. From
              diagnostics to complex treatments.
            </p>
          </div>
        </div>
      </section>

      <div className="container">
        {/* Services Grid */}
        <section className="services-grid-section section">
          <div className="services-grid">
            {servicesData.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3 style={{ fontSize: "1.3rem" }}>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-details">
                  <div className="service-detail">
                    <FaClock />
                    <span>{service.duration}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="why-choose-us section">
          <div className="section-header">
            <h2 style={{ fontSize: "1.6rem" }}>
              Why Choose SATYA HEART CLINIC?
            </h2>
            <p>
              Experience the difference that expertise, technology, and
              compassionate care make
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-item">
              <FaUserMd className="feature-icon" />
              <h3 style={{ fontSize: "1.3rem" }}>Expert Cardiologists</h3>
              <p>
                Board-certified cardiologists with years of experience in
                diagnosing and treating heart conditions.
              </p>
            </div>

            <div className="feature-item">
              <FaHeartbeat className="feature-icon" />
              <h3 style={{ fontSize: "1.3rem" }}>Advanced Technology</h3>
              <p>
                State-of-the-art diagnostic equipment and treatment facilities
                for accurate diagnosis and effective care.
              </p>
            </div>

            <div className="feature-item">
              <FaShieldAlt className="feature-icon" />
              <h3 style={{ fontSize: "1.3rem" }}>Patient-Centered Care</h3>
              <p>
                Personalized treatment plans and compassionate care that puts
                your health and comfort first.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Services;
